import mainCaller from './mainCaller';

const BASE = 'admin/api/v1/positionAuth';

// 1. 직급 목록 + 소속 직원 수 조회
export async function getPositionList(token, query) {
  return await mainCaller(`${BASE}/positions?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 2. 직급별 소속 직원 목록 조회
export async function getPositionEmployees(token, positionId, headBranchId) {
  const query = headBranchId ? `?headBranchId=${headBranchId}` : '';
  return await mainCaller(`${BASE}/positions/${positionId}/employees${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 2-1. 전체 직원 목록 조회 (직급별 그룹핑용)
export async function getAllEmployees(token, headBranchId, branchId) {
  const params = [`headBranchId=${headBranchId}`];
  if (branchId) params.push(`branchId=${branchId}`);
  return await mainCaller(`${BASE}/employees?${params.join('&')}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 3. 직급 권한 설정 조회
export async function getPositionAuths(token, positionId) {
  return await mainCaller(`${BASE}/positions/${positionId}/auths`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 4. 개별 직원 권한 조회
export async function getUserAuths(token, userId, branchId) {
  const query = branchId ? `?branchId=${branchId}` : '';
  return await mainCaller(`${BASE}/users/${userId}/auths${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 5. 직급 권한 설정 저장
export async function savePositionAuths(token, positionId, menuAuthIds, branchId) {
  const params = [];
  if (menuAuthIds) params.push(`menuAuthIds=${menuAuthIds}`);
  if (branchId) params.push(`branchId=${branchId}`);
  const query = params.length > 0 ? `?${params.join('&')}` : '';
  return await mainCaller(
    `${BASE}/positions/${positionId}/auths${query}`,
    'PUT',
    null,
    { Authorization: `Bearer ${token}` },
  );
}

// 5-1. 개별 직원 권한 저장
export async function saveUserAuths(token, userId, menuAuthIds, branchId) {
  const params = [];
  if (menuAuthIds) params.push(`menuAuthIds=${menuAuthIds}`);
  if (branchId) params.push(`branchId=${branchId}`);
  const query = params.length > 0 ? `?${params.join('&')}` : '';
  return await mainCaller(
    `${BASE}/users/${userId}/auths${query}`,
    'PUT',
    null,
    { Authorization: `Bearer ${token}` },
  );
}

// 6. 해당직급 전체 적용
export async function applyAllPositionAuths(token, positionId) {
  return await mainCaller(`${BASE}/positions/${positionId}/auths/apply-all`, 'PUT', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 6-1. 복수 직원 권한 일괄 저장
export async function bulkSaveUserAuths(token, userIds, menuAuthIds, branchId) {
  const params = [`userIds=${userIds}`];
  if (menuAuthIds) params.push(`menuAuthIds=${menuAuthIds}`);
  if (branchId) params.push(`branchId=${branchId}`);
  return await mainCaller(`${BASE}/users/auths/bulk?${params.join('&')}`, 'PUT', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 7. 직급 권한 초기화
export async function resetPositionAuths(token, positionId) {
  return await mainCaller(`${BASE}/positions/${positionId}/auths/reset`, 'PUT', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 8. 직원 비밀번호 설정 (관리자용)
export async function setEmployeePassword(token, employeeId, data) {
  return await mainCaller(`admin/api/v1/employees/${employeeId}/password`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 9. 직원 정보 수정 (대표자 설정 등)
export async function updateEmployee(token, employeeId, data) {
  return await mainCaller(`admin/api/v1/employees/${employeeId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}
